import styled from "styled-components";
import {
  mediaMinWidth,
  mediaMaxWidth,
} from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  background-color: #fff;
  border: 5px solid #e4e5e7;
  border-radius: 15px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  color: #616161;
  transform: height 0.3s ease-in-out;
  max-width: 100%;

  &:hover {
    color: #000;
  }

  &:first-child {
    border-top: 0px solid #e4e5e7;
  }

  &:last-child {
    margin-bottom: 80px;

    ${mediaMaxWidth.tablet} {
      margin-bottom: 140px;
    }
  }

  ${mediaMinWidth.smallDesktop} {
    width: 900px !important;
    right: 0;
    margin: 0 auto;
  }
`;

interface IColumnProps {
  isIE: boolean;
  flexSize: string;
  ieWidth?: boolean;
  center?: boolean;
  capitalize?: boolean;
  arrow?: boolean;
  hideOnDesktop?: boolean;
  hideOnTablet?: boolean;
  pinkArrow?: boolean;
  offerMade?: boolean;
}

export const Column = styled.div`
  display: ${(props: IColumnProps) => (props.isIE ? "table" : "flex")};
  flex-direction: column;
  flex: ${(props: IColumnProps) => props.flexSize};
  width: ${(props: IColumnProps) => !props.flexSize && "240px"};
  width: ${(props: IColumnProps) => props.ieWidth && "150px"};
  justify-content: space-evenly;
  align-items: ${(props: IColumnProps) => props.center && "center"};
  text-transform: ${(props: IColumnProps) => props.capitalize && "capitalize"};
  cursor: ${(props: IColumnProps) => props.arrow && "pointer"};
  font-size: ${(props: IColumnProps) => props.arrow && "1.8em"};
  position: ${(props: IColumnProps) =>
    props.flexSize === "unset" && "absolute"};
  right: ${(props: IColumnProps) => props.flexSize === "unset" && "40px"};

  svg.fa-chevron-right {
    position: absolute;
    right: 20px;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #673490;
    }
  }

  ${mediaMaxWidth.tablet} {
    width: ${(props) => !props.flexSize && "280px"};
  }

  ${mediaMinWidth.tablet} {
    display: ${(props: IColumnProps) => props.hideOnDesktop && "none"};
    color: ${(props: IColumnProps) =>
      props.arrow && props.pinkArrow && "#f2008c"};
    color: ${(props: IColumnProps) =>
      props.arrow && props.offerMade && "rgb(39, 174, 96)"};
  }

  ${mediaMaxWidth.tablet} {
    display: ${(props: IColumnProps) => props.hideOnTablet && "none"};
    width: ${(props: IColumnProps) => !props.flexSize && "350px"};

    svg.fa-chevron-right {
      right: 15px;
    }
  }

  ${mediaMaxWidth.phone} {
    width: ${(props: IColumnProps) => !props.flexSize && "290px"};
    font-size: ${(props: IColumnProps) => props.arrow && "1.2em"};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${mediaMaxWidth.smallPhone} {
    width: ${(props: IColumnProps) => !props.flexSize && "250px"};
    font-size: ${(props: IColumnProps) => props.arrow && "1.1em"};
    right: ${(props: IColumnProps) => props.flexSize === "unset" && "30px"};
  }
`;

export const Link = styled.a`
  margin-right: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  padding-right: 25px;
  text-decoration: underline !important;
  display: flex;
  color: #333 !important;
  font-weight: 700 !important;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #673490 !important;
  }

  ${mediaMaxWidth.phone} {
    padding-right: 30px;
  }
`;

export const ActionsCogColumn = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;

  .button-group {
    top: unset;
    z-index: unset;
    right: -15px;

    ul {
      top: 42px;
    }

    li {
      padding: 4px 5px;
      margin: 2px 8px;
    }
  }

  ${mediaMaxWidth.tablet} {
    width: 100px;
    flex: unset;
    position: absolute;
    right: 0;

    .button-group {
      top: 3px;
    }
  }
`;

interface ITopProps {
  titleField?: boolean;
  hover?: boolean;
}

export const Top = styled.div`
  display: flex;
  flex: 1;
  font-size: ${(props: ITopProps) => (props.titleField ? "1em" : "0.95em")};
  text-decoration: ${(props: ITopProps) => props.titleField && "underline"};
  cursor: ${(props: ITopProps) => props.titleField && "pointer"};
  cursor: ${(props: ITopProps) => props.hover && "pointer"};
  justify-self: center;
  margin-bottom: 2.5px;
  min-height: 22px;

  ${mediaMaxWidth.tablet} {
    min-height: 22px;
  }

  svg {
    display: flex;
    align-self: center;
    margin: 0 17px;
  }

  ${mediaMaxWidth.phone} {
    font-size: ${(props: ITopProps) => (props.titleField ? "0.85em" : "0.8em")};

    .__react_component_tooltip.place-top {
      margin-top: -2px;
      top: unset !important;
      left: unset !important;
      right: 60px !important;

      &:after {
        display: none;
      }
    }

    .__react_component_tooltip.place-right {
      margin-top: -2px !important;
      left: unset !important;
      right: 60px !important;

      &:after {
        display: none;
      }
    }
  }

  ${mediaMaxWidth.smallPhone} {
    font-size: ${(props: ITopProps) => (props.titleField ? "0.8em" : "0.75em")};
  }
`;

interface IBottomProps {
  hover?: boolean;
  numbers?: boolean;
}

interface IBottomProps {
  hover?: boolean;
  numbers?: boolean;
  desktopStack?: boolean;
  location?: boolean;
}

export const Bottom = styled.div`
  display: flex;
  flex: 1;
  margin-top: 2.5px;
  font-size: 0.95em;
  cursor: ${(props: IBottomProps) => props.hover && "pointer"};
  width: ${(props: IBottomProps) => props.numbers && "100%"};

  strong {
    margin-right: 3px;

    ${mediaMaxWidth.phone} {
      margin-right: -2px;
    }
  }

  svg {
    display: flex;
    align-self: center;
    margin: 0 7px;
  }

  ${mediaMinWidth.tablet} {
    flex-direction: ${(props: IBottomProps) => props.desktopStack && "column"};
    flex-direction: ${(props: IBottomProps) =>
      props.desktopStack && props.numbers && "row"};
    flex-flow: ${(props: IBottomProps) =>
      props.desktopStack && props.location && "column-reverse"};
    justify-content: space-around;
  }

  ${mediaMaxWidth.phone} {
    font-size: 0.85em;
  }

  ${mediaMaxWidth.smallPhone} {
    font-size: 0.75em;
  }

  .__react_component_tooltip.place-bottom {
    margin-left: -130px;
    top: unset !important;
    margin-top: 25px;
    text-align: center;
  }
`;

interface IBottomItemProps {
  numbers?: boolean;
  offerMade?: boolean;
  noDesktop?: boolean;
  noMobile?: boolean;
}

export const BottomItem = styled.div`
  flex-direction: ${(props: IBottomItemProps) => props.numbers && "column"};
  display: ${(props: IBottomItemProps) => props.numbers && "flex"};
  justify-content: space-evenly;
  flex: ${(props: IBottomItemProps) => props.numbers && "1"};
  color: ${(props: IBottomItemProps) => props.offerMade && "rgb(39, 174, 96)"};
  font-weight: ${(props: IBottomItemProps) => props.offerMade && "700"};
  min-height: 21px;

  ${mediaMinWidth.tablet} {
    display: ${(props: IBottomItemProps) => props.noDesktop && "none"};
  }

  ${mediaMaxWidth.tablet} {
    display: ${(props: IBottomItemProps) => props.noMobile && "none"};
  }
`;

export const Divider = styled.div`
  margin: 0 7px;

  ${mediaMinWidth.tablet} {
    display: none;
  }

  ${mediaMaxWidth.tablet} {
    margin: 0 5px;
  }
`;

export const CVLink = styled.a``;

export const ViewCvButton = styled.button`
  font-weight: bold;
  color: #f2008c;
  background: #fff;
  border: 1px solid #f2008c;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  padding: 7px 12px;
  font-family: Raleway;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 0.95em;
  transition: 0.15s ease-in-out;

  &:hover {
    background: #b70d6c;
    color: #fff;
    border: 1px solid #b70d6c;
  }

  &:focus {
    outline: none;
  }
`;

export const Number = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;
`;
